import { render, staticRenderFns } from "./QualityItemList.vue?vue&type=template&id=394b845a&"
import script from "./QualityItemList.vue?vue&type=script&lang=js&"
export * from "./QualityItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports